import { Link as RouterLink, useLocation, useNavigate } from 'react-router';
import { Breadcrumbs, Link, LinkProps } from '@mui/material';
import { t } from 'i18next';

interface LinkRouterProps extends LinkProps {
  to: string;
  replace?: boolean;
}

function LinkRouter(props: LinkRouterProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <Link {...props} component={RouterLink as any} />;
}

interface CustomizedBreadcrumbsProps {
  pathnameSegments: string[];
  breadcrumbNameMap: { [key: string]: string };
  replaceNavigation?: boolean;
}

const CustomizedBreadcrumbs: React.FC<CustomizedBreadcrumbsProps> = ({
  pathnameSegments,
  breadcrumbNameMap,
  replaceNavigation = false,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const breadcrumbSegments = pathnameSegments.filter(Boolean);

  if (breadcrumbSegments.length <= 1) return <></>;

  return (
    <Breadcrumbs aria-label='breadcrumb'>
      {breadcrumbSegments.map((value, index) => {
        const last = index === breadcrumbSegments.length - 1;
        const to = `/${breadcrumbSegments.slice(0, index + 1).join('/')}`;

        if (!breadcrumbNameMap[to]) return null;

        return (
          <LinkRouter
            underline='hover'
            variant={last ? 'p16Bold' : 'p16'}
            color={last ? 'secondary' : 'primary'}
            to={to}
            replace={replaceNavigation}
            onClick={(event) => {
              if (replaceNavigation) {
                event.preventDefault();

                const navigationState = location.state as { backTo?: string } | null;

                if (!last && navigationState?.backTo === to) {
                  navigate(-1);
                  return;
                }

                navigate(to, { replace: true });
              }
            }}
            key={to}>
            {t(breadcrumbNameMap[to])}
          </LinkRouter>
        );
      })}
    </Breadcrumbs>
  );
};

export default CustomizedBreadcrumbs;
